export type TagCount = {
	name: string;
	count: number;
	visible: boolean;
};

/**
 * @description The All Collection is a special collection that represents all items in a hub.
 * It is only for FE use and is not stored in the DB.
 */
export type AllCollection = {
	id: null;
	hub_id: string;
	name: string;
	tags: [];
	slug: '';
	index: 0;
	archived: false;
	min_role: 'member';
	asset_count: 0;
	tag_counts: [
		{
			name: '';
			count: 0;
			visible: false;
		}
	];
};

/**
 * @description Any collection that a user creates in a hub.
 * These are stored in the DB and excludes the "All" collection.
 */
export type CustomCollection = {
	id: string;
	hub_id: string;
	name: string;
	tags: string[] | null;
	slug: string;
	index: number;
	archived: boolean;
	min_role: string;
	asset_count: number;
	tag_counts: TagCount[] | null;
};

export type Collection = AllCollection | CustomCollection;

export const isCustomCollection = (collection: Collection): collection is CustomCollection => {
	return collection.id !== null;
};

export const isAllCollection = (collection: Collection): collection is AllCollection => {
	return collection.id === null && collection.archived === false;
};
